import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6b87cbb5"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("h2", { class: "subtitle" }, [
    /*#__PURE__*/ _createElementVNode("strong", null, "Tutorials and Training")
], -1));
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "columns" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "column" }, "Please review the following important tutorials:")
], -1));
const _hoisted_3 = {
    key: 0,
    class: "columns"
};
const _hoisted_4 = { class: "column tutorialsWrapper" };
const _hoisted_5 = { style: { "display": "flex", "flex-direction": "row", "width": "100%" } };
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { style: { "flex-grow": "1" } }, null, -1));
import { onMounted, ref } from "vue";
import { notifyError } from "../../../core/utils";
import InformationCardField from "./InformationCardField.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'PartnerOnboardingFormTutorialsPage',
    props: {
        modelValue: {},
        tutorials: {}
    },
    emits: ['update:modelValue', 'back', 'proceed'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const viewedTutorials = ref(null);
        onMounted(() => {
            viewedTutorials.value = [...props.modelValue];
        });
        const onTutorialViewed = (tutorial) => {
            if (viewedTutorials.value.includes(tutorial.url))
                return;
            viewedTutorials.value.push(tutorial.url);
            emit("update:modelValue", viewedTutorials.value);
        };
        const onSubmitClicked = () => {
            for (let tutorial of props.tutorials) {
                if (!viewedTutorials.value.includes(tutorial.url)) {
                    notifyError("Please ensure that you have viewed all tutorials");
                    return;
                }
            }
            emit('proceed');
        };
        return (_ctx, _cache) => {
            const _component_SaveButton = _resolveComponent("SaveButton");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _hoisted_1,
                _hoisted_2,
                (viewedTutorials.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tutorials, (tutorial) => {
                                return (_openBlock(), _createBlock(InformationCardField, {
                                    key: tutorial.url,
                                    card: tutorial,
                                    size: "large",
                                    viewed: viewedTutorials.value.includes(tutorial.url),
                                    onViewed: ($event) => (onTutorialViewed(tutorial))
                                }, null, 8, ["card", "viewed", "onViewed"]));
                            }), 128))
                        ])
                    ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_component_SaveButton, {
                        class: "mr-2",
                        large: "",
                        label: "Back",
                        icon: "fa-chevron-left",
                        onClick: _cache[0] || (_cache[0] = ($event) => (emit('back')))
                    }),
                    _createVNode(_component_SaveButton, {
                        large: "",
                        label: "Complete Onboarding",
                        icon: "fa-check",
                        onClick: _cache[1] || (_cache[1] = ($event) => (onSubmitClicked()))
                    })
                ])
            ], 64));
        };
    }
});
